/**
 * Origin System — Design Tokens (TypeScript)
 * Bridge entre CSS et types explicites.
 */

export const ORIGIN_TOKENS = {
  colors: {
    accent: '#7c3aed',  // Purple/Indigo
    success: '#10b981', // Emerald
    error: '#ef4444',   // Red
    warning: '#f59e0b', // Amber
  },
  glass: {
    soft: {
      bg: 'var(--origin-glass-bg)',
      blur: 'var(--origin-glass-blur)',
      border: 'var(--origin-glass-border)',
      shadow: 'var(--origin-shadow-soft)'
    },
    panel: {
      bg: 'var(--origin-glass-bg)',
      blur: 'var(--origin-glass-blur)',
      border: 'var(--origin-glass-border)',
      shadow: 'var(--origin-shadow-float)'
    },
    overlay: {
      bg: 'rgba(0, 0, 0, 0.4)',
      blur: '20px',
      border: 'rgba(255, 255, 255, 0.1)',
      shadow: '0 16px 48px rgba(0, 0, 0, 0.4)'
    }
  },
  shape: {
    radius: {
      soft: 'var(--origin-radius-soft)',
      structured: 'var(--origin-radius-soft)',
      panel: 'var(--origin-radius-panel)'
    },
    angleTension: 'var(--origin-angle-tension)'
  },
  rhythm: {
    signatureLine: 'var(--origin-line-height)',
    filament: 'var(--origin-line-height)',
    loader: '3px'
  },
  motion: {
    spring: {
      stiffness: 100,
      damping: 20,
    },
    transition: {
      duration: 0.25,
      ease: [0.16, 1, 0.3, 1], // Out-expo
    },
  },
};
